import { GameVars } from "../GameVars";

export class HandIcon extends Phaser.Group {

    private handIconImage: Phaser.Image;
    private circle: Phaser.Sprite;

    constructor(game: Phaser.Game, x: number, y: number, textureAtlas: string) {

        super(game, null, "hand-icon", false);

        this.scale.y = GameVars.scaleY;

        let circleBitmapData: Phaser.BitmapData = game.add.bitmapData(50, 50);
        circleBitmapData.ctx.beginPath();
        circleBitmapData.ctx.arc(25, 25, 25, 0, 2 * Math.PI);
        circleBitmapData.ctx.fillStyle = "#ffffff";
        circleBitmapData.ctx.fill();

        this.circle = new Phaser.Sprite(this.game, x, y, circleBitmapData);
        this.circle.anchor.set(.5);
        this.circle.alpha = .5;
        this.circle.visible = false;
        this.add(this.circle);

        this.handIconImage = new Phaser.Image(this.game, x, y, textureAtlas, "hand-icon");
        this.handIconImage.anchor.set(.15, .1);
        this.add(this.handIconImage);
    }

    public click(): void {

        this.game.add.tween(this.handIconImage.scale).to({ x: .9, y: .9 }, 350, Phaser.Easing.Cubic.Out, true, 750)
            .onComplete.add(this.showCircle, this);
    }

    private showCircle(): void {

        this.handIconImage.scale.setTo(1, 1);

        this.circle.visible = true;

        this.game.add.tween(this.circle.scale).to({ x: 1.5, y: 1.5 }, 300, Phaser.Easing.Elastic.Out, true)
            .onComplete.add(function (): void {
                this.circle.visible = false;
            }, this);

        this.game.time.events.add(1500, this.removeHandIcon, this);
    }

    private removeHandIcon(): void {

        this.game.add.tween(this.handIconImage).to({ alpha: 0 }, 750, Phaser.Easing.Cubic.Out, true)
            .onComplete.add(function (): void {
                this.destroy();
            }, this);
    }
}
